export const editorConfig = {
    backend: 'backend',
    public: 'public',
    styles: 'styles',
    pages: {
        structure: {
            code: 'index.js',
            document: {
                structure: 'structure.xml',
                data: 'data.json',
                style: 'style.wcss'
            }
        },
        folders: {
            Page: [
                { name: 'pages', type: 'Folder' },
                { variableName: 'title', type: 'DynamicFolder' }
            ]
        }
    }
};
